module.exports = __webpack_public_path__ + "img/dm.f03d42f0.svg";